import * as Styles from "../ScheduledSurveyForm.styles"
import { t } from "ttag"
import React from "react"

interface QuestionResumeProps {
    title:string,
    questionName: string,
    choices: {
        id: number,
        name: string,
        icon_url: string,
    }[],
    isCollapse: boolean,
}
export const QuestionResume = ({
  title, 
  questionName, 
  choices,
  isCollapse,
}: QuestionResumeProps) => {
  return (
    <Styles.KillerQuestion.Wrap>
      <Styles.KillerQuestion.Title>{title}</Styles.KillerQuestion.Title>
      <Styles.Question.Wording>{questionName}</Styles.Question.Wording>
      <Styles.KillerQuestion.Choices
        isCollapsible={!isCollapse}
        invite={t`Answers`}
      >
        {choices.map(choice => (
          <Styles.KillerQuestion.Choice key={choice.id}>
            {choice.icon_url &&
                <Styles.KillerQuestion.Icon
                  src={choice.icon_url}
                  alt={`icon ${choice.name}`}
                />
            }
            <Styles.KillerQuestion.Span>
              {choice.name}
            </Styles.KillerQuestion.Span>
          </Styles.KillerQuestion.Choice>
        ))}
      </Styles.KillerQuestion.Choices>
    </Styles.KillerQuestion.Wrap>
  )
}
